import React, { useEffect, useState } from 'react'

import { AllowPermission } from 'shared/components/AllowPermission'
import { HeaderWithSidebarIcon, StyledSubMenuItem } from '..'
import Popup from 'shared/components/Popup'
import { Loader } from 'shared/components/Loader'
import useAxios from 'hooks/useAxios'
import useWorkspace from 'hooks/useWorkspace'
import constants from 'config/constants'

import styled from 'styled-components'
import useModal from 'hooks/useModal'
import ReportViewCreateModal from 'organisms/ReportView/ReportViewCreateModal'

export default function ReportSubMenu() {
  const [viewPages, setViewPages] = useState([])
  const workspaceToken = useWorkspace()

  const { data, loading } = useAxios({
    url: 'reports/report-view-pages/',
  })

  useEffect(() => {
    if (data) {
      setViewPages(data.results)
    }
  }, [data])

  const {
    Modal: ModalNewReportView,
    open: openNewReportView,
    close: closeNewReportView,
    isOpen: isOpenModalNewReportView,
  } = useModal()

  const isLoading = !data && loading && viewPages.length === 0
  return (
    <div className="ui borderless vertical menu fluid secondary !border-0 !m-0">
      <HeaderWithSidebarIcon>Reports</HeaderWithSidebarIcon>
      <AllowPermission permission={constants.permissions.viewReports}>
        <StyledSubMenuItem
          className="disable header-item item"
          to={`/${workspaceToken}/reports/`}
          isActive={(_, location) => location.pathname === `/${workspaceToken}/reports/`}
        >
          <h5>Report workspace</h5>
        </StyledSubMenuItem>

        <FavoriteReportList workspaceToken={workspaceToken} />

        <h5 className="sub-menu-title item">Report views</h5>
        {isLoading ? (
          <Loader className="ml-5 !z-[-1]" />
        ) : (
          viewPages.map((view, index) => {
            return (
              <Popup.Truncated key={index} content={view.name}>
                <StyledSubMenuItem
                  className="sub-menu-item item"
                  to={{
                    pathname: `/${workspaceToken}/reports/views/${view.token}/`,
                    state: { reportViewName: view.name },
                  }}
                >
                  {view.name}
                </StyledSubMenuItem>
              </Popup.Truncated>
            )
          })
        )}
        <LinkButton
          onClick={(e) => {
            e.preventDefault()
            openNewReportView()
          }}
        >
          <span>
            <i className="mx-1 far fa-plus" />
            New report view
          </span>
        </LinkButton>

        {isOpenModalNewReportView && (
          <ReportViewCreateModal modal={ModalNewReportView} close={closeNewReportView} />
        )}
      </AllowPermission>
    </div>
  )
}

function FavoriteReportList({ workspaceToken }) {
  const [favorites, setFavorites] = useState([])

  const { data, loading } = useAxios({
    url: 'dashboard/list-favorite-view/?type=report',
  })

  useEffect(() => {
    if (data) {
      setFavorites(data.results)
    }
  }, [data])

  const noFavorite = favorites.length === 0
  const isLoading = !data && loading && noFavorite
  if (isLoading) {
    return <Loader className="ml-5 !z-[-1]" />
  } else if (noFavorite) {
    return null
  } else {
    return (
      <React.Fragment>
        <StyledSubMenuItem
          className="sub-menu-title item disable pointer-events-none"
          to="/feedback/"
        >
          <span>Favorites</span>
        </StyledSubMenuItem>

        {favorites.map((view, index) => {
          return (
            <Popup.Truncated key={index} content={view.name}>
              <StyledSubMenuItem
                className="sub-menu-item item"
                to={{
                  pathname: `/${workspaceToken}/reports/views/${view.token}/`,
                  state: { reportViewName: view.name },
                }}
              >
                {view.name}
              </StyledSubMenuItem>
            </Popup.Truncated>
          )
        })}
      </React.Fragment>
    )
  }
}

const LinkButton = styled.a`
  user-select: none;
  font-size: 14px;
  cursor: pointer;
  color: #9b9b9b;
  border: none;
  text-align: left;
  margin-left: 10px;

  &:hover {
    color: var(--blue-dark);
  }
  &.disable {
    &:hover {
      color: #9b9b9b;
    }
  }
`



// WEBPACK FOOTER //
// ./src/organisms/NavBar/ReportSubMenu/index.tsx